/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BillingAddress } from './BillingAddress';
import type { JobTitle } from './JobTitle';
export type NewClient = {
    customer_id: string | null;
    given_name: string;
    family_name: string;
    email: string;
    organization_name: string;
    salesperson_email: string | null;
    unit: NewClient.unit;
    interval: NewClient.interval;
    cost: number;
    quantity: number;
    addOns?: {
        financialAnalysis?: {
            cost: number;
        };
        marketAnalytics?: {
            cost: number;
        };
    };
    trial_period_days: number;
    decentralized_fee?: {
        fee_type: NewClient.fee_type;
        cost: number;
    };
    stripe_parent_id: string | null;
    stripe_parent_auth0_id: string | null;
    property_id: string | null;
    address: BillingAddress;
    job_title?: JobTitle | null;
    organization_report_limit?: number | null;
};
export namespace NewClient {
    export enum unit {
        PER_SEAT = 'per_seat',
        PER_UNIT = 'per_unit',
    }
    export enum interval {
        MONTH = 'month',
        YEAR = 'year',
    }
    export enum fee_type {
        FLAT = 'flat',
        PER_UNIT = 'per_unit',
    }
}

